import HrSummary from './hrSummary';
import useWrapReport from './useWrapReport';

/**
 * Composes the HR summary tab. Reads the isEmptyData flag from useWrapReport and forwards it to the HrSummary widget.
 *
 * @returns The HrSummary widget for this tab.
 */
const WrapReport = () => {
  const { isEmptyData } = useWrapReport();

  return <HrSummary isEmptyData={isEmptyData} />;
};

export default WrapReport;
